import { defineComponent, h } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

import TranslationContainer from '../TranslationContainer.jsx';

export default defineComponent({
    name: 'sform-paragraph',
    mixins: [BaseComponent],
    components: {
        TranslationContainer
    },
    data: () => ({
        bodyexpr: null,
    }),
    props: {
    },
    created() {
        if (this.element.body)
            this.bodyexpr = utils.compile(this, this.Translate(this.element.body));
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        body() {
            if(this.element.body)
                return <TranslationContainer context={this} value={this.element.body} isPossibleHtml={true}></TranslationContainer>;
            return null;
        }
    },
    methods: {
    },
    render() {
        return <p style="color: black;">{this.body}</p>;
    }
});